"use strict";

/**
 * @function
 * @description function to initiate header banner events
 */
const initHeaderBanner = () => {
    let headerBannerStatus = window.sessionStorage.getItem("hide_header_banner");
    let checkoutHeaderBannerStatus = window.sessionStorage.getItem("hide_checkout_header_banner");
    const $headerPromoBanner = $(".l-header-banner");
    const $checkoutBanner = $(".promo-banner-checkout");
    const filterBar = document.querySelector(".js-sticky-filter");

    $headerPromoBanner.find(".close").on("click", e => {
        const $this = $(e.currentTarget);

        if ($this.closest(".promo-banner-checkout").length > 0) {
            $checkoutBanner.find($headerPromoBanner).addClass("d-none");
            window.sessionStorage.setItem("hide_checkout_header_banner", "1");
        } else {
            $headerPromoBanner.addClass("d-none");
            window.sessionStorage.setItem("hide_header_banner", "1");
        }

        if (filterBar && filterBar.classList.contains("fixed-top")) {
            filterBar.style.marginTop = document.querySelector(".l-header").offsetHeight + "px";
        }
    });

    if ($(".l-cart-show").length || $(".l-header__nomenu").length || $(".l-order-confirm").length) {
        if (!checkoutHeaderBannerStatus || checkoutHeaderBannerStatus < 0) {
            $checkoutBanner.removeClass("d-none");
            $checkoutBanner.find($headerPromoBanner).removeClass("d-none");
        }
    } else {
        if (!headerBannerStatus || headerBannerStatus < 0) {
            $headerPromoBanner.removeClass("d-none");
        }
    }

    $headerPromoBanner.find(".toggle-text").on("click", function () {
        $(this).toggleClass("expanded");
    })
};


module.exports = initHeaderBanner;
